/**
 * Formats a number to a fixed number of decimal places and returns it as a string.
 * A thin wrapper around `Number.prototype.toFixed` that also handles string input,
 * which is common when values come from uncontrolled form inputs.
 *
 * NOTE: `useMeasureInUnits.jsx` imports this as `toFixed2`, which does not exist.
 * That import is currently unused at runtime, but it will throw if called.
 *
 * @param {string | number} number
 * @param {number} [digits=2] - Number of decimal places
 * @returns {string}
 */
export const toFixed = (number, digits = 2) => {
  return parseFloat(number).toFixed(digits);
};
